export default __webpack_public_path__ + "static/media/logo-transparent.62766a78.svg";